import { Lang } from '@/i18n/lang';
export function isOffline() {
    return Boolean(window.xy_is_offline);
}
export function addJsonPrefixIfOffline() {
    return isOffline() ? '.json' : '';
}
/** 页面配置按语言导出；其他离线接口仍共用原有 JSON。 */
export function getPageConfigExtension() {
    if (!isOffline())
        return '';
    const lang = window.langController?.getLang() || Lang.Chinese;
    return lang === Lang.Chinese ? '.json' : `.${encodeURIComponent(lang)}.json`;
}
